import React from 'react';

const SecretaryMessagePage = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <div className="relative bg-slate py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-slate to-crimson opacity-90"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">Secretary's Message</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">Committed to operational excellence and institutional growth</p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          {/* Main Content Card */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16">
            <div className="grid md:grid-cols-4 gap-12 mb-8">
              {/* Photo Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-gray-100 rounded-lg aspect-[3/4] flex items-center justify-center">
                  <i className="fas fa-user text-8xl text-gray-400"></i>
                </div>
                <div className="mt-6 text-center">
                  <h3 className="font-bold text-xl text-slate">Ms. Priya Sharma</h3>
                  <p className="text-base text-gray-500 mt-2">Secretary</p>
                  <p className="text-sm text-gray-400 mt-1">FiT Engineering College</p>
                </div>
              </div>
            
            {/* Message Content */}
            <div className="md:col-span-3 space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                Dear Members of the FIT Community,
              </p>
              <p className="text-gray-600 leading-relaxed">
                It gives me immense pleasure to serve as Secretary of FiT Engineering College. Our institution has consistently demonstrated its commitment to academic excellence and holistic development of our students.
              </p>
              <p className="text-gray-600 leading-relaxed">
                In my role, I have witnessed firsthand the dedication of our faculty, the enthusiasm of our students, and the unwavering support of our administrative team. Together, we create an ecosystem that nurtures talent and fosters innovation.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our focus on industry-relevant curriculum, combined with practical exposure through internships and projects, ensures that our graduates are not just job-ready but are equipped to become job creators. The numerous accolades and achievements of our alumni stand testament to the quality of education we provide.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We have established strong partnerships with leading companies and research institutions, providing our students with unparalleled opportunities for learning and growth. Our state-of-the-art infrastructure and well-equipped laboratories create an ideal environment for academic pursuit and research.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We are committed to maintaining transparency, efficiency, and student-centric policies in all our operations. Your feedback and suggestions are always welcome as we strive to continuously improve and adapt to the evolving educational landscape.
              </p>
              <p className="text-gray-600 leading-relaxed">
                I encourage all students to make the most of the resources and opportunities available at FIT. Remember, your success is our success, and we are here to support you every step of the way.
              </p>
              <p className="text-gray-600 leading-relaxed">
                I look forward to working with each of you to take FiT Institute to new heights of excellence.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold mt-8">
                Best wishes,<br/>
                <span className="text-crimson text-xl">Ms. Priya Sharma</span><br/>
                <span className="text-base font-normal">Secretary, FiT Engineering College</span>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecretaryMessagePage;